import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import * as _ from 'underscore';

import {ModalSelectorDelegate, ModalSelectorController} from '../../../shared';
import {EventsApi, EventObjectApi, NamedEventObject} from '..';

const fcaCategoriesJson = require('../fca-categories.json');

export class EventSelectorController implements ModalSelectorDelegate {
   campaignId:number;
   title:string;
   multiSelect:boolean;
   nvDisabled:boolean;
   storageId:string;
   templateUrl = 'event-selector-rows.html';
   ngModelCtrl:ng.INgModelController;
   parent:ModalSelectorController;

   fcaCategories = fcaCategoriesJson;

   fcaActivations = [
      'R&D Pro Driver Closed Course',
      'R&D Consumer Closed Course',
      'R&D Consumer Public Course',
      'Static'
   ];

   departments:NamedEventObject[];
   regions:NamedEventObject[];
   eventTypes:NamedEventObject[];
   vendorNames:NamedEventObject[];

   extraSearchKey:string;
   extraSearch = {
      categories: [],
      departments: [],
      regions: [],
      eventTypes: [],
      vendorNames: [],
      activations: []
   };

   private departmentsApi:EventObjectApi;
   private regionsApi:EventObjectApi;
   private eventTypesApi:EventObjectApi;
   private vendorNamesApi:EventObjectApi;

   static $inject = ['$uibModal', 'eventsApi', 'session', '$q', 'localStorageService'];

   constructor(
      private $modal:uib.IModalService,
      private eventsApi:EventsApi,
      private session,
      private $q:ng.IQService,
      private localStorageService
   ) {
      let brandId = this.session.getBrand().id;

      if (this.session.getOrg().slug.indexOf('fca') == 0) {
         this.departmentsApi = this.eventsApi.getEventObjectApi('departments', brandId);
         this.regionsApi = this.eventsApi.getEventObjectApi('regions', brandId);
         this.eventTypesApi = this.eventsApi.getEventObjectApi('eventTypes', brandId);
         this.vendorNamesApi = this.eventsApi.getEventObjectApi('vendorNames', brandId);
      } else {
         this.extraSearch = null;
      }
   }

   $onInit() {
      if (!this.campaignId) {
         this.campaignId = this.session.getCampaign().id;
      }

      this.title = this.multiSelect ? 'Select Events' : 'Select Event';

      if (this.extraSearch) {
         this.$q.all([
            this.departmentsApi.list(),
            this.regionsApi.list(),
            this.eventTypesApi.list(),
            this.vendorNamesApi.list()
         ]).then(results => {
            this.departments = results[0];
            this.regions = results[1];
            this.eventTypes = results[2];
            this.vendorNames = results[3];
         });
      }

      if (this.storageId) {
         this.extraSearchKey = this.storageId = '.extraSearch';
      }
   }

   get extraSearchUrl() {
      if (this.extraSearch) {
         return 'extra-event-search.html';
      }
   }

   onSelect(item, property:string) {
      let val = item.id;
      if (property == 'activations') {
         val = item;
      }

      if (this.extraSearch[property].indexOf(val) == -1) {
         this.extraSearch[property].push(val);
      } else {
         this.extraSearch[property] = _.without(this.extraSearch[property], val);
      }

      this.parent.reload();
   }

   isSelected(item, property:string) {
      if (property == 'activations') {
         return this.extraSearch.activations.indexOf(item) != -1;
      } else {
         return this.extraSearch[property].indexOf(item.id) != -1;
      }
   }

   getLabel(property:string) {
      const labels = {
         categories: {
            empty: 'Event Category',
            selected: 'Categories'
         },
         departments: {
            empty: 'Department',
            selected: 'Departments'
         },
         regions: {
            empty: 'Business Center',
            selected: 'Centers'
         },
         eventTypes: {
            empty: 'Event Type',
            selected: 'Event Types'
         },
         vendorNames: {
            empty: 'Vendor',
            selected: 'Vendors'
         },
         activations: {
            empty: 'Activation Type',
            selected: 'Activations'
         }
      };

      let count = this.extraSearch[property].length;

      if (count == 0) {
         return labels[property].empty;
      } else {
         return `${count} ${labels[property].selected}`;
      }
   }

   onClearSelection() {
      if (this.extraSearch) {
         _.each(this.extraSearch, (val, key) => this.extraSearch[key] = []);
         this.localStorageService.remove(this.extraSearchKey);
      }
   }

   open() {
      if (!this.selected) {
         this.onClearSelection();
      }

      if (this.extraSearch) {
         let savedSearch = this.localStorageService.get(this.extraSearchKey);
         if (savedSearch) {
            this.extraSearch = savedSearch;
         }
      }

      this.$modal.open({
         component: 'modalSelector',
         resolve: {
            selected: () => {
               if (ng.isArray(this.selected)) {
                  return this.selected;
               } else if (this.selected && this.selected.id) {
                  return [this.selected.id];
               }
            },
            delegate: () => this
         }
      }).result.then(result => {
         this.ngModelCtrl.$setViewValue(result);
      });
   }

   get selected() {
      return this.ngModelCtrl.$modelValue;
   }

   get buttonText():string {
      if (ng.isArray(this.selected)) {
         return `${this.selected.length} Events Selected`;
      } else if (this.selected && this.selected.name) {
         return this.selected.name;
      }

      return this.title;
   }

   load(search:string):ng.IPromise<{total:number, list:any[]}> {
      let params = {
         campaignId: this.campaignId
      };

      if (search) {
         params['search'] = search;
      }

      if (this.extraSearch) {
         this.localStorageService.set(this.extraSearchKey, this.extraSearch);

         params['categoryIds'] = this.extraSearch.categories;
         params['departmentIds'] = this.extraSearch.departments;
         params['regionIds'] = this.extraSearch.regions;
         params['eventTypeIds'] = this.extraSearch.eventTypes;
         params['vendorIds'] = this.extraSearch.vendorNames;
         params['activationTypes'] = this.extraSearch.activations;
      }

      return this.eventsApi.list(params)
         .then(model => {
            if (_.any(this.extraSearch, p => p.length > 0)) {
               this.parent.selectedIds = _.pluck(model.list, 'id');
            }

            return model;
         });
   }
}

ng.module('e360').component('eventSelector', {
   templateUrl: require('./event-selector.component.html'),
   controller: EventSelectorController,
   bindings: {
      campaignId: '<',
      multiSelect: '<',
      nvDisabled: '<',
      storageId: '<'
   },
   require: {
      ngModelCtrl: 'ngModel'
   }
});
